import React, { useEffect, useState, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useForm } from 'react-hook-form';
import RoutesApp from '../../routes';
import dayjs from 'dayjs';

//Servicios
import { DJCEService } from '../../services/api';

//Componentes
import { toast } from 'react-toastify';
import Spinner from '../../components/spinner/Spinner';
import Modal from '../../components/modal/Modal';
import DJCEList from './DJCEList';

//Estilos
import right_arrow from '../../assets/imgs/next.png';
import pencil from '../../assets/imgs/edit.png';
import post_stamp from '../../assets/imgs/post-stamp.png';

function DJCEListContainer() {
    const { token, settings, user, masters, viniedos } = useGlobalContext();
    const { register, handleSubmit, watch, setError, formState } = useForm({
        defaultValues: { myViniedo: 0 },
    });
    const Navigate = useNavigate();

    const [loader, setLoader] = useState(false);
    const [OpenPagoModal, setOpenPagoModal] = useState(false);
    const [OpenNewDJCEModal, setOpenNewDJCEModal] = useState(false);
    const [SelectedDJCE, setSelectedDJCE] = useState(0);
    const [TimbrePago, setTimbrePago] = useState(false);
    const [DJCEListData, setDJCEListData] = useState([]);

    const EnableBtn = parseInt(watch('myViniedo'));

    const TimbreModalContent = (
        <section>
            <main style={{ marginBottom: '1rem' }}>
                Usted será redireccionado a la pasarela de pagos para abonar el
                Timbre de la decalración. Por favor confirme el procedimiento
            </main>
            <footer>
                <button
                    className="btn btn-primary"
                    onClick={() => payDJCE(SelectedDJCE.id)}
                >
                    Aceptar
                </button>
                <button
                    className="btn btn-secondary"
                    onClick={() => setOpenPagoModal(false)}
                >
                    Cancelar
                </button>
            </footer>
        </section>
    );

    const NewDJCEModalContent = (
        <section>
            <main style={{ marginBottom: '1rem' }}>
                <b>ATENCIÓN: </b>Al crear la DJCE, se cerrará la DJCP existente
                y ya no se podrán crear mas guías
            </main>
            <footer>
                <button
                    className="btn btn-primary"
                    onClick={() => newDJCE({ myViniedo: EnableBtn }, true)}
                >
                    Aceptar
                </button>
                <button
                    className="btn btn-secondary"
                    onClick={() => setOpenNewDJCEModal(false)}
                >
                    Cancelar
                </button>
            </footer>
        </section>
    );

    useEffect(() => {
        const getMyDJCE = async () => {
            try {
                setLoader(true);
                const myDJCEs = await DJCEService.all({
                    token,
                    usuarioId: user.id,
                    // serie: parseInt(dayjs(new Date()).format('YYYY')),
                });
                if (myDJCEs) {
                    setDJCEListData(myDJCEs.data);
                    setTableData(buildTableData(myDJCEs.data));
                }
                setLoader(false);
            } catch (err) {
                setLoader(false);
            }
        };
        if (user.tipo !== 3) getMyDJCE();
    }, [TimbrePago]);

    /**Funcion que crea el objeto para pasarle al componente tabla y listar las DJCPs*/
    const buildTableData = (data = []) => {
        return {
            title: 'Declaraciones de Cosecha Efectiva',
            headers: [
                'ID',
                'Viñedo',
                'Fecha',
                'Timbre',
                'Habilitada',
                'Kilos Totales',
                'Cerrada',
                ' ',
            ],
            pagination: 10,
            data:
                data.length > 0
                    ? data?.map((dj) => {
                          return {
                              id: `${dj.serie}-P-${dj.numero}`,
                              viniedo: dj.viniedo,
                              fecha: dayjs(dj.fecha).format('DD-MM-YYYY'),
                              timbre: dj.timbre ? 'PAGO' : 'NO PAGO',
                              habilitada: masters.HabilitationTypes?.find(
                                  (ht) => ht.id === dj.habilitada
                              )?.nombre.replace('_', ' '),
                              kilosTotales: dj.total_Kilos,
                              cerrada: !dj.fecha_Cierre
                                  ? 'NO'
                                  : dayjs(dj.fecha_Cierre).format('DD-MM-YYYY'),
                              icons: (
                                  <div>
                                      <Link
                                          to={
                                              RoutesApp.Declaraciones
                                                  .cosechaEfectiva + dj.id
                                          }
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={right_arrow}
                                              title="Visualizar"
                                              alt="Visualizar"
                                          />
                                      </Link>
                                      {!dj.fecha_Cierre && (
                                          <Link
                                              to={
                                                  RoutesApp.Declaraciones
                                                      .nuevaCosechaEfectiva +
                                                  dj.id
                                              }
                                              className="table-icon_container"
                                          >
                                              <img
                                                  className="table-icon"
                                                  src={pencil}
                                                  title="Editar"
                                                  alt="Editar"
                                              />
                                          </Link>
                                      )}
                                      {!dj.timbre && (
                                          <Link
                                              to="#"
                                              className="table-icon_container"
                                          >
                                              <img
                                                  className="table-icon"
                                                  src={post_stamp}
                                                  title="Pagar Timbre"
                                                  alt="Pagar Timbre"
                                                  onClick={() => {
                                                      setOpenPagoModal(true);
                                                      setSelectedDJCE(dj);
                                                  }}
                                              />
                                          </Link>
                                      )}
                                  </div>
                              ),
                          };
                      })
                    : [],
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    const newDJCE = async (data, cerrarDJCP = false) => {
        try {
            setLoader(true);

            const newDJCE = await DJCEService.create({
                token,
                viniedoId: parseInt(data.myViniedo),
                cerrarDJCP,
            });

            if (newDJCE) {
                if (!newDJCE.data.declaracion.id) {
                    setOpenNewDJCEModal(true);
                } else {
                    Navigate(
                        RoutesApp.Declaraciones.nuevaCosechaEfectiva +
                            newDJCE.data.declaracion.id
                    );
                }
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            return err;
        }
    };

    async function payDJCE(id) {
        try {
            setLoader(true);

            const PaidDJCE = await DJCEService.payTimbre({
                token,
                id,
            });

            if (PaidDJCE) {
                setTimbrePago(!TimbrePago);
                setOpenPagoModal(false);
                toast('DJCE pagada con éxito', { type: 'success' });
            }

            setLoader(false);
        } catch (err) {
            toast('Pago de DJCE fallido', { type: 'error' });
            setLoader(false);
            return err;
        }
    }

    return loader ? (
        <Spinner />
    ) : (
        <>
            <Modal
                title={'Pago de Timbre'}
                questionModal
                isOpen={OpenPagoModal}
                onClose={() => setOpenPagoModal(false)}
            >
                {TimbreModalContent}
            </Modal>
            <Modal
                title={'Nueva DJCE'}
                questionModal
                isOpen={OpenNewDJCEModal}
                onClose={() => setOpenNewDJCEModal(false)}
            >
                {NewDJCEModalContent}
            </Modal>
            <DJCEList
                functions={{
                    register,
                    handleSubmit,
                    watch,
                    setError,
                    formState,
                    newDJCE,
                    setOpenNewDJCEModal,
                }}
                states={{
                    DJCEListData,
                    tableData,
                    viniedos,
                    settings,
                    EnableBtn,
                }}
            />
        </>
    );
}

export default DJCEListContainer;
